import { render, staticRenderFns } from "./addImportantFile.vue?vue&type=template&id=06e177a1&scoped=true&"
import script from "./addImportantFile.vue?vue&type=script&lang=js&"
export * from "./addImportantFile.vue?vue&type=script&lang=js&"
import style0 from "./addImportantFile.vue?vue&type=style&index=0&id=06e177a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e177a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e177a1')) {
      api.createRecord('06e177a1', component.options)
    } else {
      api.reload('06e177a1', component.options)
    }
    module.hot.accept("./addImportantFile.vue?vue&type=template&id=06e177a1&scoped=true&", function () {
      api.rerender('06e177a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aymentsdk/components/addImportantFile.vue"
export default component.exports